import React, { useEffect, useRef, useState } from "react";
import { getLaunchStatus } from "../config/launchConfig";
import "../assets/css/LaunchIntro.css";

const TAGLINES = [
  "The Season Of Forever Begins",
  "Handpicked. Heartfelt. Yours.",
  "Wedding Design, Reimagined",
  "Every Detail, Beautifully Made",
];

const SESSION_KEY = "sm_launch_seen";
const CURTAIN_TRAVEL_MS = 1850;

const LaunchIntro = ({ children }) => {
  const [phase, setPhase] = useState("checking");
  const [taglineIndex, setTaglineIndex] = useState(0);
  const openTimer = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const resolveGate = async () => {
      if (sessionStorage.getItem(SESSION_KEY) === "1") {
        if (!cancelled) setPhase("skipping");
        return;
      }
      try {
        const enabled = await getLaunchStatus();
        if (!cancelled) setPhase(enabled ? "closed" : "skipping");
      } catch (e) {
        if (!cancelled) setPhase("skipping"); // fail open
      }
    };

    resolveGate();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (phase === "skipping") {
      const t = window.setTimeout(() => setPhase("done"), 420);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [phase]);

  useEffect(() => {
    if (phase !== "closed") return undefined;
    document.body.classList.add("sm-launch-lock");
    const tag = window.setInterval(() => {
      setTaglineIndex((i) => (i + 1) % TAGLINES.length);
    }, 2200);
    return () => window.clearInterval(tag);
  }, [phase]);

  useEffect(() => () => {
    document.body.classList.remove("sm-launch-lock");
    window.clearTimeout(openTimer.current);
  }, []);

  const openCurtains = () => {
    if (phase !== "closed") return;
    setPhase("opening");
    openTimer.current = window.setTimeout(() => {
      document.body.classList.remove("sm-launch-lock");
      sessionStorage.setItem(SESSION_KEY, "1");
      setPhase("done");
    }, CURTAIN_TRAVEL_MS);
  };

  return (
    <>
      {children}

      {phase !== "done" && (
        <div
          className={[
            "sm-launch",
            phase === "opening" ? "sm-launch--opening" : "",
            phase === "checking" ? "sm-launch--checking" : "",
            phase === "skipping" ? "sm-launch--skipping" : "",
          ].join(" ").trim()}
          aria-hidden={phase !== "closed"}
        >
          <div className="sm-launch__ambient" aria-hidden="true" />
          <div className="sm-launch__spotlight" aria-hidden="true" />

          <section className="sm-launch__centre">
            <p className="sm-launch__kicker">The doors are open</p>
            <h1 className="sm-launch__logo" aria-label="Shaadi Material">
              <span>shaadi</span><span>Material</span>
            </h1>
            <p className="sm-launch__tagline" key={taglineIndex}>
              {TAGLINES[taglineIndex]}
            </p>
            <button
              type="button"
              className="sm-launch__button"
              onClick={openCurtains}
              disabled={phase !== "closed"}
            >
              <span>{phase === "opening" ? "Entering" : "Enter"}</span>
              <i aria-hidden="true">→</i>
            </button>
          </section>

          <div className="sm-curtain sm-curtain--left" aria-hidden="true">
            <div className="sm-curtain__shine" />
            <div className="sm-curtain__inner-edge" />
            <div className="sm-curtain__tieback" />
          </div>
          <div className="sm-curtain sm-curtain--right" aria-hidden="true">
            <div className="sm-curtain__shine" />
            <div className="sm-curtain__inner-edge" />
            <div className="sm-curtain__tieback" />
          </div>

          <div className="sm-launch__top-drape" aria-hidden="true">
            <span /><span /><span /><span /><span /><span /><span />
          </div>
          <div className="sm-launch__floor-glow" aria-hidden="true" />
        </div>
      )}
    </>
  );
};

export default LaunchIntro;